export default __webpack_public_path__ + "static/media/comment.6cc9a628.svg";